export default __webpack_public_path__ + "static/media/Exaltate's Girdle.13e4a48e.jpg";